import { toast } from "sonner";
import { Icon } from "~/components/ui";

const getErrorDisplayName = (message: string) => {
  if (!message) return "";

  // If it's a standard "Field is required" or "Field is missing" message, just return the first word
  // This handles messages like "Title is required", "Severity is required", etc.
  if (
    message.toLowerCase().includes("required") ||
    message.toLowerCase().includes("missing")
  ) {
    return message.split(" ")[0];
  }

  // Otherwise, return the full message so we can diagnose technical issues
  return message;
};

function formatWords(words: string[]) {
  if (words.length === 0) return null;
  if (words.length === 1) return <strong>{words[0]}</strong>;

  return (
    <div className="flex flex-col gap-1">
      {words.map((word, i) => (
        <p key={i} className="text-sm">
          • <strong>{word}</strong>
        </p>
      ))}
    </div>
  );
}

const extractErrorMessages = (errors: any): string[] => {
  const messages: string[] = [];

  const recurse = (obj: any) => {
    if (!obj || typeof obj !== "object") return;

    if (obj.message && typeof obj.message === "string") {
      messages.push(obj.message);
      return;
    }

    Object.values(obj).forEach((value) => recurse(value));
  };

  recurse(errors);
  return messages;
};

export const showCombinedErrorToast = (errors: any) => {
  const errorMessages = extractErrorMessages(errors);
  const displayNames = errorMessages.map((msg) => getErrorDisplayName(msg));
  const uniqueNames = [...new Set(displayNames)].filter(Boolean);

  if (uniqueNames.length === 0) return;

  toast(
    <div className="flex items-start gap-2">
      <Icon name="CircleAlert" className="text-danger-500 mt-1" />
      <div className="flex flex-col">
        <p className="text-sm font-medium text-black mb-1">
          Please check the following:
        </p>
        {formatWords(uniqueNames)}
      </div>
    </div>,
    {
      className: "!max-w-full",
      duration: 5000,
    },
  );
};
